import { Component, OnInit } from '@angular/core';

import { environment } from '../../../../environments/environment';
@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by"><b>DMSVO
    </b> {{ year | date:'yyyy' }} - {{ versionName }}</span>
  `
})
export class FooterComponent implements OnInit {
  year: Date;
  versionName: string;
  versionBuild: string;
  ngOnInit(): void {
    this.year = new Date();
    this.versionName = environment.stage === 'pre' ? `${environment.versionName}(${environment.versionBuild})` : environment.versionName;
    this.versionBuild = environment.versionBuild;
  }

}
